module.exports = __webpack_public_path__ + "media/images/lb/172-e1d573dfce48f75c24eb88e10e3c4309.svg";